import { useEffect, useState } from 'react'
import {getRelatedImageryListFromSelectedFeature, setObserverCallbacks } from './DocOverlayVM';

const useDocOverLayHook = ({view,setCurrentValue,layerIds}):any[] => {
  const {parcels,tractMaps,recordsOfSurvey,parcelMaps}=layerIds
  const [payload, setPayload] = useState([]);
    
    
  useEffect(() => {
      setObserverCallbacks(view,setPayload,setCurrentValue,layerIds)
      getRelatedImageryListFromSelectedFeature(view,view.popup.selectedFeature,layerIds)?.then((res) => setPayload(res))
      return () => {
      };
  }, []);
  return payload
}

export default useDocOverLayHook